import { Link, useLocation, useNavigate } from "react-router-dom";

export default function CustomLink(props) {

    const location = useLocation();
    const navigate = useNavigate();

    return (
        <>
            <Link to={props.to} className={props.className} onClick={e => {
                e.preventDefault();
                if (location.pathname === props.to) {
                    navigate('refresh');
                    setTimeout(() => {
                        navigate(props.to);
                    }, 100);
                }
                else {
                    navigate(props.to);
                }
            }}>
                {props.children}
            </Link>
        </>
    );
}